<template>
  <div>
    <ul class="steps has-content-centered">
      <li class="steps-segment" v-for="(tab, key) in tabs" :class="{ 'is-active': tab.isActive }" :key="key">
        <span class="steps-marker"></span>
        <div class="steps-content">
          <p v-if="tab.isActive" class="is-size-5 tab-name">
            {{ tab.name }}
          </p>
        </div>
      </li>
    </ul>
    <div class="tab-details">
      <slot></slot>
    </div>
<!--    <br/>-->
<!--    <div class="field is-grouped">-->
<!--      <div class="control" v-if="currentActive > 0">-->
<!--        <button @click="previousTab()" class="button is-primary">Anterior</button>-->
<!--      </div>-->
<!--      <div class="control" v-if="currentActive < totalTabs - 1">-->
<!--        <button @click="nextTab()" class="button is-link">Continuar</button>-->
<!--      </div>-->
<!--      <div class="control" v-if="currentActive == totalTabs -1" >-->
<!--        <button @click="submit()" class="button is-success">Enviar</button>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>

export default {
  name: 'form-wizard',

  data() {
    return {
      tabs: [],
      currentActive: 0,
      totalTabs: 0
    }
  },

  created() {
    this.tabs = this.$children
  },

  mounted() {
    this.totalTabs = this.tabs.length
  },

  methods: {
    previousTab() {
      this.currentActive--

      this.tabs.forEach(tab => {
        tab.isActive = false
      })
      this.tabs[this.currentActive].isActive = true
    },

    nextTab(plusPages = 1) {
      //Validate input
      this.$root.$validator.validate('step' + (this.currentActive + plusPages)+'.*').then(valid => {
        if (valid) {
          this.currentActive += plusPages

          this.tabs.forEach(tab => {
            tab.isActive = false
          })

          this.tabs[this.currentActive].isActive = true
        }
      })
    },

    submit() {
      this.$root.$validator.validate('step'+this.totalTabs+'.*').then(valid => {
        if (valid) {
          alert("Everything passes ! Ready to Submit")
        }
      })
    }
  }
}
</script>

<style lang="scss">
$primary: #0091f8;
$grey: #dae6ec;
.steps:not(.is-hollow) .steps-segment.is-active ~ .steps-segment .steps-marker:not(.is-hollow) {
  background-color: $grey!important;
  color: rgba(0, 0, 0, 0.7);
}

.tab-name {
  color: $primary;
  max-width: 4.7rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Segoe UI, Arial, sans-serif;
}

</style>